<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold mb-1 pb-2 mx-2">{{ trans.map_setting }}</div>
        </div>
        <div class="overflow-y-auto h-screen pb-20 mapsetting-content">
            <div class="mx-4">
                <div class="mt-8 py-2">
                    <div class="divider my-1" v-if="isChangeMapStyle && !useMaplibre"></div>
                    <div class="">
                    <ul class="menu overflow-visible p-3">
                        <li class="menu-title">
                        <span>{{ trans.dark_mode }}</span>
                        </li>
                        <li>
                        <label class="label cursor-pointer">
                            <span class="ChangeTheme label-text">{{ trans.dark_mode }}</span>
                            <input
                            type="checkbox"
                            class="toggle toggle-primary"
                            id="theme-dark"
                            value="dark"
                            @change="handleThemeChange"
                            />
                        </label>
                        </li>
                    </ul>
                    </div>
                </div>
                <div class="description">
                    <div class="" v-if="isChangeMapStyle && !useMaplibre">
                        <ul class="menu overflow-visible p-3">
                            <li class="menu-title">
                                <span>{{ trans.map_style }}</span>
                            </li>
                            <li
                                v-for="(styleLink, styleName) in mapStyles"
                                :key="'map-style-' + styleName"
                                @click="changeMapStyle(styleLink)"
                            >
                                <label class="label cursor-pointer" :for="'style-' + styleName">
                                    <span class="label-text">{{ styleName }}</span>
                                    <input
                                        type="radio"
                                        class="radio radio-primary"
                                        name="map_style"
                                        :id="'style-' + styleName"
                                        :value="styleLink"
                                        :checked="currentStyle == styleLink"
                                    />
                                </label>
                            </li>
                            <li v-if="hasCustomStyle" @click="changeMapStyle(mapData.style)">
                                <label class="label cursor-pointer" for="map-style-custom"
                                    ><span class="label-text">Custom</span>
                                    <input
                                        id="map-style-custom"
                                        type="radio"
                                        class="radio radio-primary"
                                        name="map_style"
                                        :value="mapData.style"
                                        :checked="currentStyle == mapData.style"
                                /></label>
                            </li>
                        </ul>
                    </div>
                    <template v-if="mapData.switch_language && !useMaplibre">
                        <div class="divider my-1"></div>
                        <div class="">
                            <ul class="menu overflow-visible p-3">
                                <li class="menu-title">
                                    <span>{{ trans.language }}</span>
                                </li>
                                <li
                                    v-for="langCode in mapData.languages"
                                    :key="'lang-' + langCode"
                                    :id="'switch-lang-btn-' + langCode"
                                    @click="switchLanguage(langCode)"
                                >
                                    <label class="label cursor-pointer" :for="'lang-' + langCode">
                                        <span class="label-text">{{
                                            languageCodeText[langCode]
                                        }}</span>
                                        <input
                                            class="radio radio-primary"
                                            type="radio"
                                            name="lang"
                                            :id="'lang-' + langCode"
                                            :value="langCode"
                                            :checked="langCode == lang"
                                            @change="$emit('changedLang', $event.target.value)"
                                        />
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <div class="divider my-1" v-if="isChangeMapStyle && !useMaplibre"></div>
                    <div class="">
                        <div class="menu overflow-visible p-3">
                            <label class="menu-title">
                                <span>{{ trans.display }}</span>
                            </label>
                            <select v-model="currentTheme" class="select select-bordered w-full" @change="$emit('changedTheme', $event.target.value)">
                                <option v-for="theme in themes" :key="theme" :value="theme">{{ theme }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['trans'],
    props: {
        mapData: {
            type: Object,
            required: true
        },
        mySmartMap: {
            type: Object,
            required: true
        },
        show: {
            type: Object,
            required: true
        },
        lang: {
            type: String,
            required: true
        },
        switchLanguage: {
            type: Function,
            required: true
        },
        isChangeMapStyle: {
            type: Boolean,
            default: true
        },
        useMaplibre: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasCustomStyle() {
            for (let key in this.mapStyles) {
                const style = this.mapStyles[key];
                if (style == this.mapData.style) {
                    return false;
                }
            }

            return true;
        }
    },
    data() {
        return {
            mapStyles: {
                streets: 'mapbox://styles/mapbox/streets-v11',
                light: 'mapbox://styles/mapbox/light-v10',
                dark: 'mapbox://styles/mapbox/dark-v10',
                outdoors: 'mapbox://styles/mapbox/outdoors-v11',
                satellite: 'mapbox://styles/mapbox/satellite-streets-v11'
            },
            showSetting: this.show,
            languageCodeText: {
                browser: this.trans.your_browser_language,
                en: this.trans.locales.en,
                ja: this.trans.locales.ja,
                'zh-Hans': this.trans.locales['zh-CN'],
                'zh-Hant': this.trans.locales['zh-TW'],
                ko: this.trans.locales.ko,
                fr: this.trans.locales.fr,
                de: this.trans.locales.de,
                it: 'Italiano',
                pt: 'Português',
                ru: 'Русский язык',
                es: this.trans.locales.es,
                ar: 'اللغة العربية'
            },
            themes: [
                'light',
                'dark',
                'cupcake',
                'bumblebee',
                'emerald',
                'corporate',
                'synthwave',
                'retro',
                'valentine',
                'halloween',
                'garden',
                'forest',
                'aqua',
                'lofi',
                'pastel',
                'fantasy',
                'black',
                'luxury',
                'dracula',
                'cmyk',
                'autumn',
                'business',
                'acid',
                'lemonade',
                'night',
                'coffee',
                'winter',
                'blue',
                'pink',
                'green',
                'yellow',
                'gray',
                'original1',
                'original2'
            ],
            currentStyle: this.mapData.style,
            currentTheme: this.mapData.theme_color
        };
    },
    methods: {
        changeMapStyle(payload) {
            this.currentStyle = payload;
            var switchLangBtn = document.querySelector('#switch-lang-btn-' + this.lang);
            var self = this;

            this.mySmartMap.once('styledata', function () {
                const waiting = () => {
                    if (!self.mySmartMap.isStyleLoaded()) {
                        setTimeout(waiting, 100);
                    } else {
                        switchLangBtn.click();
                        return;
                    }
                };
                waiting();
            });
        },
        handleThemeChange(event) {
            if (event.target.checked) {
                this.currentTheme = 'dark';
                this.$emit('changedTheme', 'dark');
                this.currentStyle = 'mapbox://styles/mapbox/dark-v10';

            } else {
                this.currentTheme = this.mapData.theme_color;
                this.$emit('changedTheme', this.mapData.theme_color);
                this.currentStyle = this.mapData.style;

            }
        }
    },
    watch: {
        currentStyle(newVal) {
            this.mySmartMap.setStyle(newVal);
        },
        showSetting: {
            deep: true,
            immediate: true,
            handler: function () {
                this.$emit('changedShowSetting', this.showSetting);
            }
        }
    }
};
</script>

<style>
.mapsetting-content{
    padding-bottom: 10rem;
}
@media screen and (max-width:639px) {
    .mapsetting-content{
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
</style>